// extracted by mini-css-extract-plugin
module.exports = {"Input":"Search_Input__3fTT2","Icon":"Search_Icon__iHn-0"};